<form [formGroup]="commentForm" (ngSubmit)="save()">
    <div class="modal-header">

        <p *ngIf="!readonly" class="modal-title"><strong>Add Comments</strong></p>
        <p *ngIf="readonly" class="modal-title"><strong>Comments</strong></p>
        <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

    </div>
    <div class="modal-body">
        <div *ngIf="!readonly" class="col-12">
            <label>Message</label>
            <textarea formControlName="comment" maxlength="10000" spellcheck="true" class="form-control" rows="9"></textarea>
        </div>

        <div *ngIf="!readonly" class="col-12 text-center mt-3">
            <button class="btn btn-outline-primary me-2" (click)="modal.dismiss()"
                onclick="javascript:return false;">Cancel</button>
            <span *ngIf="!editMode"><button type="submit" [disabled]="DisableSaveUpdate"
                 class="btn btn-secondary me-2">Add</button></span>
            <span *ngIf="editMode"><button type="submit" [disabled]="DisableSaveUpdate"
                 class="btn btn-secondary me-2">Update</button></span>
            <span *ngIf="IsActivityComment">
            <button type="submit" (click)="onCommentSubmit()" class="btn btn-secondary">Submit</button></span>
        </div>
        <div class="col-12 mt-3 ">
            <p *ngIf="!readonly"><strong>Comments</strong></p>
            <div class="scrollable">
                <table class="table table-bordered">
                    <tr *ngFor="let comment of comments;let i = index">
                        <td>
                            <p style="white-space:pre-wrap;">{{comment.comment}}</p>
                            <p class="com"> {{comment.employeeName}} |
                                {{comment.createdDate | localDate:'dd-MMM-yy hh:mm:ss a' }}
                            </p>
                        </td>
                      <td ><button type="button" class="btn btn-secondary me-2 float-end" (click)="UpdateCurrentDT()" *ngIf="i==0 && isPendingComment">Current date and time</button></td>
                        <td class="btnEdit">
                            <a (click)="editComment(comment)" *ngIf="employeeId === comment.employeeId && comment.commentType !== noteComment"><img src="design/images/edit.png" /></a>
                        </td>
                    </tr>
                </table>
            </div>

        </div>
    </div>
</form>
